import { Outlet } from "react-router";

import { Container } from "@mui/material";
import { styled } from "@mui/system";

import { UserDataComponentProps } from "../types/interfaces";
import authenticatedOnly from "./Base/AuthenticatedOnly/AuthenticatedOnly";
import Navbar from "./Navbar/Navbar";

const DefaultLayoutRoot = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  height: "100%",
  overflow: "hidden",
  width: "100%",
}));

const DefaultLayoutWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
  paddingTop: theme.spacing(6),
  [theme.breakpoints.up("md")]: {
    paddingTop: theme.spacing(9),
  },
}));

const DefaultLayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
});

const DefaultLayoutContent = styled("div")({
  flex: "1 1 auto",
  height: "100%",
  maxWidth: "100%",
});

const DefaultLayout = ({ data }: UserDataComponentProps) => {
  return (
    <DefaultLayoutRoot>
      <Navbar firstName={data.USGetAccount.firstName} />
      <DefaultLayoutWrapper>
        <DefaultLayoutContainer>
          <DefaultLayoutContent>
            <Container
              maxWidth="lg"
              sx={{ py: 4, px: 2, lg: { py: 5, px: 6 } }}
            >
              <Outlet />
            </Container>
          </DefaultLayoutContent>
        </DefaultLayoutContainer>
      </DefaultLayoutWrapper>
    </DefaultLayoutRoot>
  );
};

export default authenticatedOnly(DefaultLayout);
